import { render } from "./Home.vue?vue&type=template&id=a536f962&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=a536f962&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a536f962"

export default script